export default __webpack_public_path__ + "static/DSC_0044-1591898631837b2df8ef5939bcd6b48d.jpg";